<template>
  <div>
    <h2 :class="{ 'mt-0': !isAVRMobile }">{{ title }}</h2>
    <p v-if="text">{{ text }}</p>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';

export default {
  name: 'Hero',
  extends: Hero,
};
</script>

<style scoped lang="scss">
h2 {
  margin-bottom: 16px;
}
p {
  margin-bottom: 16px;
}
</style>
